const getId = (hex) => `color-${hex}`;

const createDropdownItems = (data) => {
  if (data.length < 2) {
    return '';
  }

  return data.reduce((acc, curr) => {
    return (acc += `
        <option 
            value="${curr.id}" 
            data-label="${curr.label}"
        >
            ${curr.label}
        </option>`);
  }, '');
};

const createTabs = (data) => {
  if (data.length < 2) {
    return '';
  }

  return data.reduce((acc, curr, index) => {
    return (acc += `<button type="button" class="tab ${
      index == 0 ? 'tab--active' : ''
    }" data-content-id="${curr.id}">${curr.label}</button>`);
  }, '');
};

const createImages = (colors) => {
  const defaultColorIndex = colors.findIndex((color) => color.isDefault);
  return (
    colors.reduce((acc, curr, index) => {
      const activeColor = defaultColorIndex > -1 ? defaultColorIndex == index : index == 0;

      return (acc += `<img class="preview-image ${
        activeColor ? 'preview-image--active' : ''
      }" src="${curr.src}" alt="" data-id="${getId(curr.hex)}" ${index > 0 ? 'lazy' : ''} />`);
    }, '') ?? ''
  );
};

const createColors = (colors) => {
  const defaultColorIndex = colors.findIndex((color) => color.isDefault);
  return (
    colors.reduce((acc, curr, index) => {
      const activeColor = defaultColorIndex > -1 ? defaultColorIndex == index : index == 0;

      return (acc += `
            <li class="color-item">
                <button type="button" class="color ${
                  activeColor ? 'color--active' : ''
                }" data-color="${curr.hex}" aria-label="${curr.label}" data-for="${getId(
        curr.hex,
      )}"></button>
            </li>`);
    }, '') ?? ''
  );
};

const createContents = (data, layout) => {
  const mobile = layout.mobile.toLowerCase() === 'bottom' ? 'reverse-mobile' : '';
  const desktop = layout.desktop.toLowerCase() === 'right' ? 'reverse-desktop' : '';
  const [gridStart, gridEnd] = layout.grid.split('-');

  return data.reduce((acc, curr, index) => {
    const images = createImages(curr.colors ?? []);
    const colors = createColors(curr.colors ?? []);

    return (acc += `
        <div class="content-wrapper row ${index > 0 ? 'hidden' : ''}" data-content-id="${curr.id}">
            <div class="contents ${desktop} ${mobile}" style="--color-spot--content-start-flex:${
      gridStart ? gridStart : 1
    }; --color-spot--content-end-flex:${gridEnd ? gridEnd : 1};">
                <div class="col-md-6 content-start">
                    <div class="preview">
                        ${images}
                    </div>
                    <ul class="color-list">
                        ${colors}
                    </ul>
                </div>
                <div class="col-md-6 content-end">
                    <div class="richtext">
                        ${curr.text}
                    </div>
                </div>
            </div>
        </div>`);
  }, '');
};

const renderTemplate = ({ element, contents, tabs, dropdown, layout }) => {
  const desktop = layout.desktop.toLowerCase() === 'right' ? 'navigation-reverse-desktop' : '';

  const template = `
        <section class="color-spot">
            <div class="container wrapper">
            ${
              dropdown.trim() && tabs.trim()
                ? `
                <div class="navigation row">
                    <div class="tabs-dropdown">
                        <div class="form-select" data-select>
                            <select class="tab-select">
                                ${dropdown}
                            </select>
                        </div>
                    </div>
                    <div class="${desktop}">
                        <div class="tabs">
                            <div class="slider"></div>
                            ${tabs}
                        </div>
                    </div>
                </div>
                `
                : ''
            }
                ${contents}
            </div>
        </section>
    `;

  element.innerHTML = template;
};

export const createColorSpot = (element, { data, layout }) => {
  const tabs = createTabs(data);
  const dropdown = createDropdownItems(data);
  const contents = createContents(data, layout);

  renderTemplate({ element, contents, tabs, dropdown, layout });
};
